import React from 'react';
import MessageItem from './MessageItem';
import CustomScrollBar from '../../../../../components/CustomScrollBar';
import './scrollBarStyles.scss';
import { useTheme } from 'styled-components';

const MessageList = props => {
  const { messages, navigation, setActiveMessage } = props;
  const { MessageList } = useTheme();

  return (
    <CustomScrollBar
      customClassNames="custom-scrollbar-message-list"
      containerStyle={{
        marginTop: '2rem',
        width: '95%',
        height: '100%',
      }}
      customStyle={MessageList.ScrollBarCustomStyle}
    >
      {messages
        ?.filter(message => !message?.deleted)
        .map(filteredMessage => (
          <MessageItem
            key={filteredMessage.message_id}
            message={filteredMessage}
            messageDetailsHandle={setActiveMessage}
            navigation={navigation}
            {...props}
          />
        ))}
    </CustomScrollBar>
  );
};

export default MessageList;

